export const PASSWORD_RESET_COOLDOWN_SECONDS = 60;
const STORAGE_KEY = 'passwordReset.resendAvailableAt';

type CooldownStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export const getPasswordResetCooldownRemaining = (
  now = Date.now(),
  storage: CooldownStorage = window.sessionStorage
): number => {
  const availableAt = Number(storage.getItem(STORAGE_KEY));
  if (!Number.isFinite(availableAt) || availableAt <= now) {
    storage.removeItem(STORAGE_KEY);
    return 0;
  }
  return Math.ceil((availableAt - now) / 1000);
};

export const startPasswordResetCooldown = (
  seconds = PASSWORD_RESET_COOLDOWN_SECONDS,
  now = Date.now(),
  storage: CooldownStorage = window.sessionStorage
): void => {
  if (Number.isFinite(seconds) && seconds > 0) {
    storage.setItem(STORAGE_KEY, String(now + Math.ceil(seconds) * 1000));
  }
};

export const getPasswordResetRetryAfter = (error: unknown): number | null => {
  const response = (error as {
    response?: {
      status?: number;
      headers?: Record<string, unknown>;
      data?: { data?: { retry_after?: unknown } };
    };
  } | null)?.response;
  if (response?.status !== 429) return null;

  const raw = response.headers?.['retry-after'] ?? response.data?.data?.retry_after;
  const seconds = Number(raw);
  return Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : PASSWORD_RESET_COOLDOWN_SECONDS;
};
